module.exports = __webpack_public_path__ + "img/pattern_withoutbackgr-dark.4bf8d970.png";